"use client";
import useIsConsentReady from "src/lib/client/useIsConsentReady";
import styles from "./BlueskyWithConsent.module.css";
import EmbedConsentPlaceholder from "src/components/richtext/EmbedConsentPlaceholder";
import Script from 'next/script';

//#region [Props]
type BlueskyWithConsentProps = {
    value: {
        blueskyEmbedCode: string;
    }
};
//#endregion

//#region [Component]
export default function BlueskyWithConsent({ value }: BlueskyWithConsentProps) {
    const { isConsentReady } = useIsConsentReady();
    if (!isConsentReady) {
        return <EmbedConsentPlaceholder className={styles.SEmbedConsentPlaceholder} />;
    }
    return <>
        <div dangerouslySetInnerHTML={{ __html: value.blueskyEmbedCode }}></div>
        <Script src="https://embed.bsky.app/static/embed.js" strategy="afterInteractive" />
    </>;
}
//#endregion